/**
 * @file     gpc.ts
 * @readme   ../CLAUDE.md
 * @purpose  Global Privacy Control checks shared by the browser pixels and the
 *           server conversion legs. The privacy and cookie policies promise GPC
 *           is honoured for Google Analytics, Google Ads and the Meta Pixel.
 *           Also reads the banner analytics opt-out for the server legs.
 */

import { analyticsBlockedByCookies } from './consent';

export function browserGpcEnabled(): boolean {
  if (typeof navigator === 'undefined') return false;
  return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
}

export function hasGpcSignal(headers: Headers): boolean {
  return headers.get('sec-gpc') === '1';
}

/**
 * The visitor turned analytics off in the cookie banner, or is in an opt-in
 * region (Quebec) and has not accepted yet.
 */
export function hasAnalyticsOptOut(headers: Headers): boolean {
  return analyticsBlockedByCookies(headers.get('cookie'));
}
